var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnambraBuild(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 10,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 28.3327V16.2368C27.4999 15.3222 27.4999 14.8649 27.237 14.4789C26.974 14.093 26.4896 13.8393 25.5208 13.332L24.2882 12.6865C22.7673 11.8901 22.0069 11.4919 21.4201 11.7386C20.8333 11.9853 20.8333 12.7032 20.8333 14.1389V17.4993",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3334 28.334H11.6667",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4999 16.666H25.8333M27.4999 19.166H25.8333M27.4999 21.666H25.8333",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 20.8333C16.6667 19.262 16.6667 18.4763 17.1549 17.9882C17.6431 17.5 18.4287 17.5 20.0001 17.5C21.5714 17.5 22.3571 17.5 22.8452 17.9882C23.3334 18.4763 23.3334 19.262 23.3334 20.8333V28.3333H16.6667V20.8333Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5833 20.834H20.4166M19.5833 23.334H20.4166",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 23.3333C13.6071 23.3333 14.1667 22.5871 14.1667 21.6667C14.1667 20.7462 13.6071 20 12.9167 20C12.2264 20 11.6667 20.7462 11.6667 21.6667C11.6667 22.5871 12.2264 23.3333 12.9167 23.3333Z",
    stroke: "#FFAC06",
    strokeWidth: 1.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 23.334V28.334",
    stroke: "#FFAC06",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnambraBuild);
export default __webpack_public_path__ + "static/media/anambra-build.7c0c895ab4e67f98d73ef4a224509851.svg";
export { ForwardRef as ReactComponent };